import { useQuery, useMutation } from "@tanstack/react-query";
import { POST } from "../../../../../services/index";
import { message } from "antd";

export const UseFetchCreateInputAudit = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const endPoint = `/api/v1/importInputAudit`;
      // อาร์กิวเมนต์ที่ 3 ของ POST คือ token ไม่ใช่ options — ของเดิมส่ง { timeout } เข้าไป
      // ทำให้ Authorization กลายเป็น "[object Object]" และ timeout ก็ไม่ได้ถูกใช้อยู่ดี
      return await POST(endPoint, payload);
    }
  });
};